import React, { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import { saveAs } from "file-saver";
import csvIcon from "../../assets/images/icons/csv.png";
import pdfIcon from "../../assets/images/icons/pdf.png";
import docIcon from "../../assets/images/icons/doc.png";
import docxIcon from "../../assets/images/icons/doc.png";
import xlsIcon from "../../assets/images/icons/xls.png";
import pptIcon from "../../assets/images/icons/ppt.png";
import {
  Tooltip,
  useMediaQuery,
  useTheme,
  Button,
  CircularProgress,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { s3baseUri } from "../../config/config";
import DocumentModelBox from "./DocumentModalBox";

function DocumentPreview({ files, data }) {
  console.log(files, "filesfilesfilesfiles");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [previewDoc, setPreviewDoc] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [currentType, setCurrentType] = useState("other_document");
  const [downloadingIndex, setDownloadingIndex] = useState(null);

  const getFileExtension = (url) => {
    try {
      return url.split(".").pop().split("?")[0].toLowerCase();
    } catch {
      return "";
    }
  };

  const getFileType = (ext) => {
    const imageTypes = ["jpg", "jpeg", "png", "gif", "webp"];
    if (imageTypes.includes(ext)) return "image";
    if (ext === "pdf") return "pdf";
    if (["mp3", "wav", "ogg"].includes(ext)) return "audio";
    return "other_document";
  };

  const getFileIcon = (ext) => {
    const iconSize = isMobile ? 36 : 65;
    switch (ext) {
      case "pdf":
        return (
          <img
            src={pdfIcon}
            alt="PDF"
            style={{ width: iconSize, height: iconSize }}
          />
        );
      case "doc":
        return (
          <img
            src={docIcon}
            alt="DOC"
            style={{ width: iconSize, height: iconSize }}
          />
        );
      case "docx":
        return (
          <img
            src={docxIcon}
            alt="DOCX"
            style={{ width: iconSize, height: iconSize }}
          />
        );
      case "xls":
      case "xlsx":
        return (
          <img
            src={xlsIcon}
            alt="Excel"
            style={{ width: iconSize, height: iconSize }}
          />
        );
      case "ppt":
      case "pptx":
        return (
          <img
            src={pptIcon}
            alt="PowerPoint"
            style={{ width: iconSize, height: iconSize }}
          />
        );
      case "csv":
        return (
          <img
            src={csvIcon}
            alt="CSV"
            style={{ width: iconSize, height: iconSize }}
          />
        );
      default:
        return "";
    }
  };

  const normalizeUrl = (url) => {
    try {
      if (!url) return "";
      if (url.startsWith("http")) return url;
      return s3baseUri + url;
    } catch {
      return url || "";
    }
  };

  const withForcedAttachment = (url, filename) => {
    try {
      const u = new URL(url);
      u.searchParams.set(
        "response-content-disposition",
        `attachment; filename=${filename}`
      );
      return u.toString();
    } catch (e) {
      const sep = url.includes("?") ? "&" : "?";
      return (
        url +
        sep +
        "response-content-disposition=" +
        encodeURIComponent(`attachment; filename=${filename}`)
      );
    }
  };

  const triggerDownloadViaIframe = (url) => {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = url;
    document.body.appendChild(iframe);
    setTimeout(() => {
      try {
        document.body.removeChild(iframe);
      } catch {}
    }, 60000);
  };

  const handleDownload = async (value, index = 0) => {
    setDownloadingIndex(index);
    let path = "";
    if (value?.document_type === "image") {
      path = value?.document_images_url?.thumbnail_1;
    } else if (value?.document_type === "audio") {
      path = value?.document_file_url;
    } else {
      path = value?.uri;
    }
    const file_path = normalizeUrl(path);
    const extension = getFileExtension(path);
    const fileName = `${data?.firs_name || "document"}.${extension || "file"}`;
    try {
      const res = await fetch(file_path, {
        mode: "cors",
        credentials: "omit",
        referrerPolicy: "no-referrer",
      });
      if (res.status === 200) {
        const blob = await res.blob();
        saveAs(blob, fileName);
      } else {
        const a = document.createElement("a");
        a.href = file_path;
        a.download = fileName;
        a.rel = "noopener";
        a.target = "_self";
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (err) {
      const a = document.createElement("a");
      a.href = file_path;
      a.download = fileName;
      a.rel = "noopener";
      a.target = "_self";
      document.body.appendChild(a);
      a.click();
      a.remove();
    } finally {
      setDownloadingIndex(null);
    }
  };

  const handleBatchDownload = async () => {
    if (!docs?.length) return;
    for (let i = 0; i < docs.length; i++) {
      await handleDownload(docs[i], i);
      await new Promise((r) => setTimeout(r, 1200)); // delay to prevent blocking
    }
  };

  const handleOpenPreview = (doc) => {
    const ext = getFileExtension(doc.uri);
    setCurrentType(getFileType(ext));
    setPreviewDoc({ ...doc, type: getFileType(ext) });
    setOpenModal(true);
  };
  console.log(previewDoc, "previewDocpreviewDocpreviewDocpreviewDocpreviewDoc");

  const handleCloseModal = () => {
    setOpenModal(false);
    setPreviewDoc(null);
  };

  const docs = files?.map((file) =>
    typeof file === "string" ? { uri: file } : file
  );

  return (
    <div style={{ overflowX: "hidden" }}>
      {/* Optional Download All Button */}

      {/* Grid Layout */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(4, 1fr)",
          gap: "15px",
          marginBottom: "30px",
        }}
      >
        {docs?.map((doc, idx) => {
          const fileUrl = doc.uri || "";
          const ext = getFileExtension(fileUrl);
          return (
            <div
              key={idx}
              style={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                padding: isMobile ? "10px" : "15px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: isMobile ? "8px" : "25px",
                minHeight: "80px",
                position: "relative",
                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                background: "#fff",
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {getFileIcon(ext)}
              </div>
              <div
                style={{
                  display: "flex",
                  gap: isMobile ? "8px" : "15px",
                  alignItems: "center",
                  marginRight: isMobile ? "" : "12px",
                }}
              >
                <Tooltip title="Preview">
                  <VisibilityIcon
                    onClick={() => handleOpenPreview(doc)}
                    style={{
                      color: "navy",
                      cursor: "pointer",
                      fontSize: isMobile ? "20px" : "24px",
                    }}
                  />
                </Tooltip>
                <Tooltip title="Download">
                  {downloadingIndex === idx ? (
                    <CircularProgress size={isMobile ? 20 : 24} />
                  ) : (
                    <DownloadIcon
                      onClick={() => handleDownload(doc, idx)}
                      style={{
                        color: "navy",
                        cursor: "pointer",
                        fontSize: isMobile ? "20px" : "24px",
                      }}
                    />
                  )}
                </Tooltip>
              </div>
            </div>
          );
        })}
      </div>

      {/* Preview Modal */}
      <DocumentModelBox
        open={openModal}
        handleClose={handleCloseModal}
        image_url={previewDoc?.uri}
        type={currentType}
        previewDoc={previewDoc}
      />
    </div>
  );
}

export default DocumentPreview;
